import { useState as s, useEffect as n } from "react";
import u from "../services/ApiService.js";
import { useSelector as a } from "react-redux";
function l() {
  const { user: t } = a((e) => e.app.datastate), [c, r] = s([]);
  return n(() => {
    const e = async () => {
      try {
        const { data: o } = await u(t.userToken).GetAccounts({ id: t._id });
        r(o.payload);
      } catch (o) {
        console.error("Error fetching accounts:", o);
      }
    };
    t?.userToken == null || t?._id == null || (r([]), e());
  }, [t?._id, t?.userToken]), {
    accounts: c
  };
}
export {
  l as default
};
